import { graphql } from 'gatsby'
import React from 'react'
import SEO from '../components/shared/Seo'
import Seo from '../components/seo'
import SectionFeatureGeneric from '../components/SectionFeatureGeneric/SectionFeatureGeneric'
import { Brand } from '../components/Brand/brand'
import { Banner } from '../components/Banner/Banner'
import { Video } from '../components/Video/media'
import { PageListing } from '../components/PageListing/PageListing'
import HeroImage from '../components/HeroBackground/HeroImage/HeroImage'
import {useLocale} from '../hooks'
import {useUrl} from '../hooks/layout/useUrl'
const ArticlePage = ({
    location,
    pageContext,
    data:{
        contentfulEkaterraArticlePage:{
            title,
            slug,
            node_locale,
            seoTitle,
            seoDescription,
            thumbnailTitle,
            thumbnailImage,
            bannerWidthFull,
            content
        }
    }
}) => {
    const lang = useUrl()
    return (
        <>
        <Seo
            title={seoTitle}
            description={seoDescription && seoDescription.seoDescription}
            node_locale={node_locale}
            lang = {lang}
            />
            {
                content.map((section:any, id:number)=>{    
                    switch(section.__typename){
                        case 'ContentfulSectionComponentHero':
                            return(
                                bannerWidthFull ? <HeroImage data={section} key = {id}/> : <Banner data={section} key = {id}/>  
                            )
                            case 'ContentfulComponentFeature':
                                return(
                                    <SectionFeatureGeneric
                                        data={section}
                                        key = {id}
                                        articleBanner = 'true'
                                    />
                                )
                    
                            case 'ContentfulComponentMedia' :
                                return(
                                    <Video data ={section} key = {id}/>
                                )
                            case 'ContentfulComponentMenuGroup' :
                                return(
                                    <PageListing data ={section} key = {id}/>
                                    )
                            case 'ContentfulEkaterraSubSection' :
                                return(
                                    <Brand data ={section} key = {id}/>
                                    )
                        default:
                            return null
                    }
                })
            }

        </>
    )        
        
}
export const ArticlePageQuery = graphql`
    query EkaterraArticlePage($id:String!){
        contentfulEkaterraArticlePage(id:{eq:$id}) {
            name
            node_locale
            slug
            seoTitle
            seoDescription{
                seoDescription
              }
            thumbnailTitle
            bannerWidthFull
            content {
                __typename
                ... on ContentfulSectionComponentHero {
                    id
                    name
                    title
                    image {
                        fluid{
                            ...GatsbyContentfulFluid_withWebp_noBase64
                        }
                        title
                    }
                    mobileImage {
                        fluid{
                            ...GatsbyContentfulFluid_withWebp_noBase64
                        }
                        title
                    }
                    description {
                        raw
                    }
                }
                ... on ContentfulComponentFeature {
                  id
                  title
                  headingLevel
                  alignment
                  images {
                    fluid{
                        ...GatsbyContentfulFluid_withWebp_noBase64
                    }
                    title
                }
                  description {
                    raw
                  }
                }
                ... on ContentfulComponentMedia {
                    name
                    youTubeUrl
                }
                ... on ContentfulComponentMenuGroup {
                    id
                    menuItems {
                      ... on ContentfulEkaterraArticlePage {
                        name
                        slug
                        thumbnailTitle
                        thumbnailImage {
                            fluid{
                                ...GatsbyContentfulFluid_withWebp_noBase64
                            }
                            title
                        }
                        thumbnailDescription {
                          thumbnailDescription
                        }
                      }
                    }
                }
                ... on ContentfulEkaterraSubSection {
                    id
                    title
                    headingAlignmentLeft
                    wideDescription
                    headingLevel
                    images {
                        fluid{
                            ...GatsbyContentfulFluid_withWebp_noBase64
                        }
                        title
                    }
                    description {
                      raw
                    }
                  }
              }
              
        }
    }
`

export default ArticlePage